import { Fragment, h } from "preact";
import { useSelector } from "react-redux";

import i18n from "../i18n";

import Tooltip from "./Tooltip.jsx";
import { selectCompany } from "../store/index.js";
import Icon from "./Icon.jsx";

export default function AppliedIcon({ user, ...props }) {
  const currentCompany = useSelector(selectCompany);

  if (!user.projects || user.projects.length === 0) {
    return;
  }

  const tooltipId = `applied-tooltip-${user.id}`;

  return (
    <>
      <Icon class={props.class} data-tooltip-id={tooltipId}>
        applied
      </Icon>
      {currentCompany && user.projects && (
        <Tooltip
          className="nioomi-tooltip nioomi-tooltip__wide"
          id={tooltipId}
          place="bottom"
        >
          {i18n.t("component.applied_icon.tooltip", {
            count: user.projects.length,
            name: user.name,
            company: currentCompany.name,
          })}
          <ul>
            {user.projects.map((project) => (
              <li>{project}</li>
            ))}
          </ul>
        </Tooltip>
      )}
    </>
  );
}
